// src/features/receipts/insuranceReceiptSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
    fetchInsuranceReceipts,
    fetchInsuranceReceiptCode,
    fetchInsuranceDueVouchers,
    fetchInsuranceDueEmis,
    fetchInsuranceCustomerBalance,
    saveInsuranceReceipt,
    deleteInsuranceReceipt,
    fetchInsuranceDirectExpenseAccounts,
    fetchCustomerList
} from "./insuranceReceiptThunk";
import { currentDateTime } from "../../lib/functions";

const initialState = {
    entryDate: currentDateTime(),
    receipts: [],
    receiptCode: "",
    dueVouchers: {},
    dueEmis: {},
    balances: {},
    directExpense: null,
    loading: false,
    error: null,
    selectedReceipt: null,
    isEditReceipt: false,
};

const insuranceReceiptSlice = createSlice({
    name: "insuranceReceipts",
    initialState,
    reducers: {
        resetInsuranceReceipts: () => initialState,
        setInsuranceEntryDate(state, action) {
            state.entryDate = action.payload;
        },
        setSelectedInsuranceReceipt(state, action) {
            state.selectedReceipt = action.payload;
        },
        setIsEditInsuranceReceipt(state, action) {
            state.isEditReceipt = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInsuranceReceipts.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchInsuranceReceipts.fulfilled, (state, action) => {
                state.loading = false;
                state.receipts = action.payload;
            })
            .addCase(fetchInsuranceReceipts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchInsuranceReceiptCode.fulfilled, (state, action) => {
                state.receiptCode = action.payload;
            })
            .addCase(fetchInsuranceDueVouchers.fulfilled, (state, action) => {
                state.dueVouchers[action.payload.customerId] = action.payload.vouchers;
            })
            .addCase(fetchInsuranceDueEmis.fulfilled, (state, action) => {
                state.dueEmis[action.payload.customerId] = action.payload.emis;
            })
            .addCase(fetchInsuranceCustomerBalance.fulfilled, (state, action) => {
                state.balances[action.payload.customerId] = { total_balance: action.payload.balance };
            })
            .addCase(saveInsuranceReceipt.fulfilled, (state, action) => {
                // server returns a message + id, but we will refetch main list in UI after save
                // Optionally push to list:
                if (action.payload && action.payload.id) {
                    // minimal push behaviour
                    state.receipts.push({ rcv_id: action.payload.id, ...action.payload });
                }
            })
            .addCase(deleteInsuranceReceipt.fulfilled, (state, action) => {
                state.receipts = state.receipts.filter((r) => r.rcv_id !== action.payload.id);
            })
            .addCase(fetchInsuranceDirectExpenseAccounts.fulfilled, (state, action) => {
                state.directExpense = action.payload;
            })

            .addCase(fetchCustomerList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCustomerList.fulfilled, (state, action) => {
                state.loading = false;
                state.customersList = action.payload;
            })
            .addCase(fetchCustomerList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const {
    resetInsuranceReceipts,
    setInsuranceEntryDate,
    setSelectedInsuranceReceipt,
    setIsEditInsuranceReceipt,
} = insuranceReceiptSlice.actions;

export default insuranceReceiptSlice.reducer;
